var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 15",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 3L6.75 0.75L4.5 3M6.75 0.75V8.25M3.00017 6C2.30126 6 1.9518 6 1.67615 6.11418C1.30861 6.26642 1.01642 6.55842 0.864181 6.92596C0.75 7.20162 0.75 7.55109 0.75 8.25V11.85C0.75 12.6901 0.75 13.1102 0.91349 13.431C1.0573 13.7133 1.2866 13.9427 1.56885 14.0865C1.88972 14.25 2.31007 14.25 3.15015 14.25H10.3501C11.1902 14.25 11.61 14.25 11.9308 14.0865C12.2131 13.9427 12.4429 13.7133 12.5867 13.431C12.7502 13.1102 12.75 12.6901 12.75 11.85V8.25C12.75 7.55109 12.7499 7.20162 12.6357 6.92596C12.4835 6.55842 12.1916 6.26642 11.824 6.11418C11.5484 6 11.1989 6 10.5 6",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgShare;